import bundleloader from './bundle-loader';

export default bundleloader.routes();
